import { useStore } from './index';

/**
 * Hook to get reactive typography tokens from the theme store.
 * Returns the font families for editorial (headings) and mono (UI) text.
 *
 * Usage:
 * const { fontMono, fontEditorial } = useTypography();
 *
 * Note: Component must be wrapped with MobX observer() to react to changes.
 */
export function useTypography() {
  const { uiThemeStore } = useStore();
  const { selectedFontTheme } = uiThemeStore;

  return {
    fontMono: selectedFontTheme.mono,
    fontEditorial: selectedFontTheme.editorial,
    fontTheme: selectedFontTheme,
  };
}
